module.exports = __webpack_public_path__ + "assets/web-icon1.f377703e.svg";